/**
 * Check In New Revision page.
 * Rendered when route is /check-in-new-revision.
 */
import React, { useState } from "react";
import { Stack } from "@fluentui/react";
import { useTheme } from "../../theme/OAS365Theme";
import { CHECKIN_FORM_LAYOUT_MIN_WIDTH_PX } from "../../redux/constants/metaData";
import CheckinNewRevision from "./components/CheckinNewRevision";

function CheckInNewRevisionPage() {
  const theme = useTheme();
  const [searchValue, setSearchValue] = useState("");
  const handleSearch = () => {
    // Bind to revision search when needed
  };

  return (
    <Stack
      enableScopedSelectors
      styles={{ root: { background: theme.colors.backgroundColor, overflow: "hidden", height: "100%" } }}
      tokens={{ childrenGap: 0, padding: 0 }}
    >
      <Stack.Item
        grow
        styles={{
          root: {
            flex: "1 1 auto",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflowX: "auto",
            overflowY: "hidden",
            WebkitOverflowScrolling: "touch",
          },
        }}
      >
        <div
          style={{
            minWidth: CHECKIN_FORM_LAYOUT_MIN_WIDTH_PX,
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            flex: "1 1 auto",
            minHeight: 0,
          }}
        >
          <Stack grow>
            <Stack.Item
              grow
              styles={{
                root: {
                  height: "calc(100vh - 100px)",
                  background: theme.colors.backgroundColor,
                  padding: "5px",
                  margin: "0 10px",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  minHeight: 0,
                },
              }}
            >
              <div style={{ marginRight: "10px", flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
                <CheckinNewRevision />
              </div>
            </Stack.Item>
          </Stack>
        </div>
      </Stack.Item>
    </Stack>
  );
}

export default CheckInNewRevisionPage;
